export default {"src":"/_next/static/media/upload.5b57afd8.svg","height":12,"width":15,"blurWidth":0,"blurHeight":0};